"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducerPath = exports.settingsApiMiddleware = exports.settingsApiReducer = exports.useUpdateProfileSettings = exports.useGetProfileSettings = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const api_1 = require("../../api/profiles/api");
const settingsApi = (0, react_1.createApi)({
    reducerPath: 'settingsApi',
    baseQuery: (0, react_1.fetchBaseQuery)({
        baseUrl: '/',
    }),
    tagTypes: ['settings'],
    endpoints: (builder) => ({
        getProfileSettings: builder.query({
            queryFn: async () => {
                try {
                    const settings = await (0, api_1.getCurrentClientSettings)();
                    return { data: settings.data };
                }
                catch (error) {
                    return { error };
                }
            },
            providesTags: ['settings'],
        }),
        updateProfileSettings: builder.mutation({
            queryFn: async (clientSettingsUpdate) => {
                try {
                    const settings = await (0, api_1.updateCurrentClientSettings)({
                        clientSettingsUpdate,
                    });
                    return { data: settings.data };
                }
                catch (error) {
                    return { error };
                }
            },
            invalidatesTags: ['settings'],
        }),
    }),
});
exports.useGetProfileSettings = settingsApi.useGetProfileSettingsQuery, exports.useUpdateProfileSettings = settingsApi.useUpdateProfileSettingsMutation, exports.settingsApiReducer = settingsApi.reducer, exports.settingsApiMiddleware = settingsApi.middleware, exports.reducerPath = settingsApi.reducerPath;
//# sourceMappingURL=api.js.map